import { Box, styled, TextField } from '@mui/material';

export const SearchContainer = styled(Box)<{ isExpanded: boolean }>(({ isExpanded }) => ({
  display: 'flex',
  alignItems: 'center',
  transition: 'width 0.3s ease',
  width: isExpanded ? '250px' : '40px',
  overflow: 'hidden',
}));

export const StyledTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    height: '36px',
    fontSize: '0.875rem',
  },
  '& .MuiInputBase-input': {
    padding: '8px 0',
  },
});
